export const ACTIVE_ORG_ID_COOKIE_NAME = "active_org_id"
